// Manual tier changes from the admin students page.
//
// Setting a student's tier GRANTS every course that tier unlocks; it never
// revokes anything (dispute-safe - use per-enrollment revoke for that).


export type TierGrantAction = "create" | "restore" | "skip";

/** What to do with one enrollment when granting a tier's course. */
export function tierGrantAction(existing: { revokedAt: Date | null } | null): TierGrantAction {
  if (!existing) return "create"; // never had it → enroll
  if (existing.revokedAt) return "restore"; // had it revoked → un-revoke, keep history
  return "skip"; // already active → leave grantedAt/grantedBy untouched
}

type TierCourse = { id: string; group?: string; tiers: string[] };
export type GroupTiers = { group: string; tiers: { name: string; courseIds: string[] }[] };

/** Tiers per course group, read from the courses' own `tiers` tags (smallest tier first).
 *  A tier belongs to the group of its grouped courses; ungrouped extras (e.g. a bonus course) ride along. */
export function tiersByGroup(courses: TierCourse[]): GroupTiers[] {
  const courseIds = new Map<string, string[]>();
  const groupOf = new Map<string, string>();
  for (const c of courses)
    for (const t of c.tiers) {
      courseIds.set(t, [...(courseIds.get(t) ?? []), c.id]);
      if (c.group && !groupOf.has(t)) groupOf.set(t, c.group);
    }
  const out = new Map<string, GroupTiers>();
  for (const [name, ids] of courseIds) {
    const group = groupOf.get(name) ?? "อื่นๆ";
    if (!out.has(group)) out.set(group, { group, tiers: [] });
    out.get(group)!.tiers.push({ name, courseIds: ids });
  }
  for (const g of out.values()) g.tiers.sort((a, b) => a.courseIds.length - b.courseIds.length);
  return [...out.values()];
}

/** A person's tier in a group = the biggest tier whose courses they can all open ("" if none). */
export function currentTier(group: GroupTiers, activeCourseIds: Set<string>): string {
  let best = "";
  for (const t of group.tiers) if (t.courseIds.every((id) => activeCourseIds.has(id))) best = t.name;
  return best;
}
